import { api } from '~/shared/api';

/**
 * @return {Promise<axios.AxiosResponse<Account>|void>}
 */
export const handleProfile = async () => await api.get('/profile/').catch((e) => console.warn(e));
